<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6iv0ET/tc-custom/9780253009623.jpg?1728259408018" alt="This image is the cover for the book What Pragmatism Was, American Philosophy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">What Pragmatism Was, American Philosophy
      </h1>
      <p class="bookDescription body article font2">
        <b>A history and exploration of this quintessentially American philosophy.</b><br/><br/>F. Thomas Burke shows how the original “maxim of pragmatism” was understood differently by the two earliest American pragmatists, William James and Charles S. Peirce. Burke reconciles these differences by casting pragmatism as a philosophical stance that endorses distinctive conceptions of <i>belief</i> and <i>meaning</i>. In particular, on Burke’s view, a pragmatist conception of <i>meaning</i> as encapsulated in the pragmatic maxim should be understood as both inferentialist and operationalist in character.<br/><br/>Burke unravels a complex early history of this philosophical tradition, discusses contemporary conceptions of pragmatism found in current US political discourse, and explores what this quintessentially American philosophy means today.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        F. Thomas Burke
      </h2>
      
      <p class="authorDescription body article"><P>F. Thomas Burke is Professor of Philosophy at the University of South Carolina. He is author of Dewey's New Logic: A Reply to Russell (1994) and co-editor of Dewey's Logical Theory: New Studies and Interpretations (2002) and George Herbert Mead in the Twenty-First Century (2013).</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?926643bc